'use strict';

var $ = global.jQuery;
var $window = $(window);
var $body = $(document.body);


// Mobile menu
var menu = $('.masthead__navbar-menu');
$('.masthead__navbar-toggle').on('click', function() {
    menu.toggleClass('active');
});

// Fix masthead
$window.scroll(function () {
	var scrollTop = $window.scrollTop();

	if ( scrollTop > 27 && !$body.hasClass('fixed-masthead') ) {
    	$body.addClass('fixed-masthead');
    } else if ( scrollTop < 28 ) {
    	$body.removeClass('fixed-masthead');
    }
});